<template>
    <section class="tickets">

        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">
                        {{ user.display_name }}
                    </span>
                </div>
                <div class="level-item" v-if="user.display_name != user.email">
                    <span class="title">
                        <small class="has-text-grey">{{ user.email }}</small>
                    </span>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">

                            <div class="column">

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Domain Access</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="tag in tags" :key="`tag_${tag.id}`">
                                            <td>
                                                <b-checkbox type="is-info"
                                                    :native-value="tag.id"
                                                    v-model="checkboxTagIds"
                                                    :disabled="(checkboxTagIdsBusy.indexOf(tag.id) > -1) || tags.length==1">
                                                    {{ tag.display_name }}
                                                </b-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <section class="m-t-md">
                                    <b-button
                                        type="is-default m-r-sm"
                                        @click.prevent="$router.push({ name: 'users' })"
                                    >Back</b-button>
                                </section>

                            </div>

                            <div class="column">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>App Access</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="app in apps" :key="`app_${app.id}`">
                                            <td>
                                                <b-checkbox type="is-info"
                                                    :native-value="app.id"
                                                    @change.native="updateApps"
                                                    :disabled="apps.length==1"
                                                    v-model="checkboxAppIds">
                                                    {{ app.name }}
                                                </b-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="column is-half">
                                <table class="table" v-if="userLoggedIn.id === user.id">
                                    <thead>
                                        <tr>
                                            <th>Profile</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <b-switch type="is-info"
                                                    :native-value="true"
                                                    :value.sync="sendNoEmails"
                                                    v-model="sendNoEmails"
                                                    @input="updateUser"
                                                    >
                                                    Send No Emails
                                                </b-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>

    import Vue from "vue";
    import _ from 'lodash/lodash';
    import JsonDenormalizer from '@/helpers/JsonDenormalizer.js';

    export default {
        name: "UserEdit",
        data() {
            return {
                user: {},
                tags: [],
                firstLoadDone: false, // to help prevent watchers from firing on first data population
                checkboxTagIds: [],
                checkboxTagIdsBusy: [],
                checkboxAppIds: [],
                checkboxAppIdsBusy: [],
                apps:[],
                sendNoEmails:false
            };
        },
        computed: {
            auth: {
                get() {
                    return this.$store.state.auth;
                }
            },
            loading: {
                get() {
                    return this.$store.state.loading;
                },
                set(value) {
                    this.$store.commit("SET_LOADING", value);
                }
            },
            userLoggedIn(){
                return this.$store.state.user
            }
        },
        watch: {
            checkboxTagIds: function(next, prev) {
                const vm = this;
                const id = _.xor(next, prev).shift();
                const was_removed = (next.indexOf(id) == -1);
                if (vm.firstLoadDone) {
                    vm.toggleTag(id, was_removed);
                }
            }
        },
        created() {
            const vm = this;
            this.loading = true;
            this.getRouteData()
                .then(data => {
                    const { user, tags } = data;
                    vm.user = user;
                    this.sendNoEmails = user.send_no_emails ? true : false;
                    vm.tags = tags;
                    vm.populateCheckedTagsFromUser(user);
                })
                .catch(err => {
                    // eslint-disable-next-line
                    window.console && console.log(err);
                })
                .finally(() => {
                    vm.$nextTick(() => {
                        vm.firstLoadDone = true;
                    });
                    vm.loading = false;
                });

            Vue.$userService.appList(vm.$route.params.id).then((response)=>{
                this.checkboxAppIds = _.map(response.data,'id');
            })
            Vue.$appService.appList().then((response)=>{
                this.apps = response
            })
        },
        methods: {

            getRouteData() {
                const vm = this;
                return new Promise((resolve, reject) => {
                    return Promise.all([
                        vm.getUser(vm.$route.params.id, { includes: 'tags' }),
                        vm.getTags(),
                    ])
                    .then(all => {
                        let data = {
                            user: all[0],
                            tags: all[1],
                        }
                        return resolve(data);
                    })
                    .catch(err => {
                        return reject(err);
                    });
                })
            },

            getUser(id, params) {
                const vm = this;
                params = typeof params !== 'undefined'
                    ? params
                    : {}
                let user_id = id || vm.$route.params.id;
                return new Promise((resolve, reject) => {
                    return Vue.$userService.getUser(user_id, params)
                        .then(data => {
                            return resolve(JsonDenormalizer.denormalize(data));
                        })
                        .catch(err => {
                            return reject(err);
                        });
                });
            },

            getTags() {
                return new Promise((resolve, reject) => {
                    return Vue.$tagService.getList()
                        .then(data => {
                            return resolve(JsonDenormalizer.denormalize(data));
                        })
                        .catch(err => {
                            return reject(err);
                        });
                });
            },

            populateCheckedTagsFromUser(user) {
                let ids = []
                if (user && user.tags) {
                    user.tags.forEach(t => {
                        ids.push(t.id);
                    });
                }
                this.checkboxTagIds = ids;
            },

            toggleTag(tag_id, remove) {
                const vm = this;
                let promises = [];
                const user_id = this.$route.params.id;
                if (vm.checkboxTagIdsBusy.indexOf(tag_id) == -1) {
                    vm.checkboxTagIdsBusy.push(tag_id);
                }
                if (remove) {
                    promises.push(Vue.$userService.removeTag(user_id, tag_id));
                }
                else {
                    promises.push(Vue.$userService.addTag(user_id, tag_id));
                }
                return Promise.all(promises)
                    .finally(() => {

                        this.$buefy.toast.open({
                            message:'Tag synced!',
                            type:'is-success'
                        })
                        vm.checkboxTagIdsBusy = _.remove(vm.checkboxTagIdsBusy, (id) => {
                            return (id != tag_id);
                        });
                    });
            },
            updateApps(){
                Vue.$userService.addApps(this.$route.params.id,{app_ids:this.checkboxAppIds}).then(()=>{
                    this.$buefy.toast.open({
                        message:'App synced!',
                        type:'is-success'
                    })
                })
            },
            updateUser() {
               Vue.$userService.updateUser(this.$route.params.id,{send_no_emails:this.sendNoEmails}).then(()=>{
                    this.$buefy.toast.open({
                        message:'User updated!',
                        type:'is-success'
                    })
               })
            }
        }
    };

</script>